import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import Decimal from 'decimal.js';
import { getTotal as getChargeTotal } from '~/components/BillModal/utils/BillClientModal.utils';
import { serviceCostModel, serviceModel } from '~/models';
import { BillingStageType } from '~/models/manual-service-billing';
import { utils } from '~/utils';
import { BillingType, ServiceFormDataType } from '../../BillClientModal.types';
import { generateStageDescription } from '../../utils/lineItem.utils';
export const resolveServiceCost = (item)=>{
    var _ref;
    const { service, fullService } = item;
    if (service.type !== ServiceFormDataType.Stages || !serviceCostModel.isFixedPrice(fullService.cost)) {
        return fullService.cost;
    }
    const specificStage = service.billingStages.find((stage)=>stage.stageNumber === service.stageNumber);
    const fallbackStage = service.billingStages.find((stage)=>stage.type === BillingStageType.Available);
    const stagePrice = (_ref = specificStage === null || specificStage === void 0 ? void 0 : specificStage.amount) !== null && _ref !== void 0 ? _ref : fallbackStage === null || fallbackStage === void 0 ? void 0 : fallbackStage.amount;
    return stagePrice != null ? _object_spread_props(_object_spread({}, fullService.cost), {
        price: stagePrice
    }) : fullService.cost;
};
export const rateText = (cost, costDisplayTexts)=>{
    const formattedPrice = utils.formatDollarAmount(serviceCostModel.price(cost));
    if (!serviceCostModel.isVariablePrice(cost)) return formattedPrice;
    return "".concat(formattedPrice, "/").concat(serviceCostModel.formattedUnitName(cost, costDisplayTexts));
};
export const preapprovedText = (cost)=>{
    if (serviceCostModel.isRangePrice(cost)) return utils.getPriceRangeText(cost);
    if (serviceCostModel.isVariablePrice(cost) && cost.unitCap != null) {
        return utils.formatNumberWithCommas(cost.unitCap);
    }
    return null;
};
export const itemDisplayName = (item)=>item.type === BillingType.Service ? item.fullService.name : item.name;
export const itemSelectName = (item, outOfScopeTemplates)=>{
    var _ref;
    if (item.type === BillingType.Service) return item.fullService.name;
    if (item.name) return item.name;
    const template = outOfScopeTemplates.find((candidate)=>candidate.id === item.charge.serviceTemplateId);
    return (_ref = template === null || template === void 0 ? void 0 : template.name) !== null && _ref !== void 0 ? _ref : '';
};
export const itemSubtitle = (item, stageTexts)=>{
    if (item.type !== BillingType.Service || item.service.type !== ServiceFormDataType.Stages) return '';
    return generateStageDescription({
        service: item.fullService,
        stageNumber: item.service.stageNumber,
        t: stageTexts
    });
};
export const lineItemTotal = (item)=>{
    if (item.type === BillingType.Charge) {
        const { quantity, rate, serviceTemplateId, discount } = item.charge;
        return getChargeTotal(quantity, rate, serviceTemplateId, discount);
    }
    if (serviceCostModel.isRangePrice(item.fullService.cost)) {
        const rate = item.service.price;
        const total = rate ? utils.applyDiscount(+rate, serviceModel.discount(item.fullService)) : new Decimal(0);
        return Decimal.max(total, 0);
    }
    const quantity = item.service.quantity ? new Decimal(+item.service.quantity) : new Decimal(0);
    return Decimal.max(serviceCostModel.finalPrice(resolveServiceCost(item), quantity), 0);
};
export const editableInput = (state, input)=>state === 'input' ? input : undefined;
